import React from 'react';
import { SectionItem } from './StyledSectionComponents';

export default function SectionItemView({
    text, dataTest, key, onClick,
}) {
    return (
        <SectionItem
            key={key}
            data-test={dataTest}
            onClick={onClick}
        >
            {text}
        </SectionItem>
    );
}
